export { default } from './clients-mobile';
